import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_or_recruiting_agency_prov_foreign_migrants_w_a_sig'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_or_recruiting_agency_prov_foreign_migrants_w_a_sig',
  name: 'Does the facility (or recruiting agency) provide foreign migrants with a signed written employment contract prior to leaving their home country?',
  description:
    'The intent of this question is to understand if foreign migrants sign an employment contract in a language they understand PRIOR TO leaving their home country (also known as "country of origin").\r\r\n\r\r\nFor example, if the facility signs contracts with foreign workers, but only AFTER they arrive in the country the facility is located (in other words, the "host country"), answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6200,
  sectionId: '2.2.5.3',
  impactArea: 'Vulnerable Groups (Migrant Workers, Young Workers)',
  impactAreaId: 'VULNERABLE_GROUP',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
